define('core/models/Forum',[
    'backbone',

    'core/UniqueModel',
    'core/api',
], function (
    Backbone,

    UniqueModel,
    api
) {
    'use strict';

    var Forum = Backbone.Model.extend({
        defaults: {
            settings: {},
            followUrl: 'forums/follow',
            unfollowUrl: 'forums/unfollow',
            isFollowing: false,
        },

        initialize: function (_attributes, options) {
            if (options && options.channel)
                this.channel = options.channel;

            this.getFeatures();
            this.on('change:id', this.getFeatures);
        },

        _changeFollowingState: function (path) {
            return api.call(path, {
                method: 'POST',
                data: {
                    target: this.get('id'),
                },
            });
        },

        follow: function () {
            this.set('isFollowing', true);

            return this._changeFollowingState(this.get('followUrl'));
        },

        unfollow: function () {
            this.set('isFollowing', false);

            return this._changeFollowingState(this.get('unfollowUrl'));
        },

        toggleFollowed: function () {
            if (this.channel && this.channel.get('options').isCurationOnlyChannel)
                return this.channel.toggleFollowed();

            var retval = this.get('isFollowing') ?
                this.unfollow() :
                this.follow();

            this.trigger('toggled:isFollowing');

            return retval;
        },

        getFeatures: function () {
            var self = this;
            if (self.id) {
                api.call('forums/details', {
                    data: {
                        forum: this.id,
                        attach: 'forumFeatures',
                    },
                    success: function (response) {
                        if (response && response.response)
                            self.set('features', response.response.features);
                    },
                });
            }
        },
    });

    UniqueModel.addType('Forum', Forum);

    return Forum;
});

